import React, { Fragment } from 'react';
import PageHeaderSkeleton from 'components/general/PageHeader/PageHeaderSkeleton';
import SkeletonParagraph from 'components/general/Skeleton/SkeletonParagraph';
import AccountLayout from './AccountLayout';

const AccountLayoutSkeleton = () => (
  <Fragment>
    <div className="l-sub-page__header">
      <PageHeaderSkeleton />
    </div>

    <div className="l-sub-page__main">
      <AccountLayout.Section>
        <SkeletonParagraph />
      </AccountLayout.Section>
    </div>
  </Fragment>
);

export default AccountLayoutSkeleton;
